import { Link } from "react-router-dom";

interface ArticleCardProps {
  id: number;
  title: string;
  excerpt: string;
  imageUrl: string;
  date: string;
  readTime: number;
  category: string;
  tags: string[];
}

export default function ArticleCard({
  id,
  title,
  excerpt,
  imageUrl,
  date,
  readTime,
  category,
  tags,
}: ArticleCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="aspect-[16/9] overflow-hidden bg-background-200">
        <img
          src={imageUrl}
          alt={title}
          title={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-2 mb-2">
          <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 whitespace-nowrap">
            {category}
          </span>
          <span className="text-xs text-foreground-500 whitespace-nowrap">{date}</span>
          <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
          <span className="text-xs text-foreground-500 whitespace-nowrap">{readTime} 分钟阅读</span>
        </div>
        <h3 className="text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors mb-2 line-clamp-2">
          {title}
        </h3>
        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
          {excerpt}
        </p>
        <div className="flex items-center gap-1.5 flex-wrap">
          {tags.map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 rounded text-xs bg-background-100 text-foreground-600 whitespace-nowrap"
            >
              #{tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}